import { getLastMonthDateRange } from '~/utils/date';
import { IFormValues } from '../types';

const getInitialValues = (): IFormValues => ({
  programId: null,
  patientIds: [],
  ...getLastMonthDateRange(),
});

export default getInitialValues;
